import React from 'react';

import { Box } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';

const handleSkip = () => {
  if (typeof window === 'undefined') {
    return;
  }
  const mainElem = document.querySelector('main');
  mainElem?.focus();
};

export const SkipLink: React.FC = () => {
  return (
    <Box
      analyticsName="cosmos-landing-page-v2-skip-to-main-content"
      aria-label="Skip navigation menu and view main content"
      onClick={handleSkip}
      className="pointer-events-none fixed top-[var(--site-promo-banner-visible-height,0px)] left-0 z-[10000] w-full -translate-y-full justify-center bg-od-bg-primary px-4 py-3 opacity-0 transition-transform duration-200 ease-in-out focus:pointer-events-auto focus:translate-y-0 focus:opacity-100"
    >
      <Text as="span" className="text-label-md text-od-content-accent-brand">
        Skip to main content
      </Text>
    </Box>
  );
};
